export default (fn) => {
  let previousState = null;
  let previousSerialized = null;
  return (nextState) => {
    if (nextState !== previousState) {
      previousState = nextState;
      previousSerialized = fn(nextState);
    }
    return previousSerialized;
  };
};
